__webpack_require__.p = "/divebell/quickstart/";